import { classes } from './Brand.st.css';

export default () => ({ className: classes.root });
